module.exports = __webpack_public_path__ + "img/pf.1c09f581.svg";